import PersonalStatistics from "./PersonalStatistics";
export default PersonalStatistics;